import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GetOrderDeliveryList } from '../../store/orderDeliveryAtom';
import { taskStatusClass } from './orderDeliveryStatus';

function OrderDeliveryScroll(props) {
  const orderDeliveryStore = GetOrderDeliveryList();
  const { id } = useParams();
  const [statusId, setStatusId] = useState('');
  const [pageSize, setPageSize] = useState(20);
  const [tableData, setTableData] = useState([]);

  // Status options come from the loaded list since the API has no separate status list
  const statusOptions = useMemo(() => {
    const seen = new Map();
    (orderDeliveryStore.task_list ?? []).forEach(item => {
      if (item?.task_status_id && !seen.has(item.task_status_id)) {
        seen.set(item.task_status_id, item.task_status_name);
      }
    });
    return [...seen.entries()].sort((a, b) => a[0] - b[0]);
  }, [orderDeliveryStore]);

  useEffect(() => {
    const list = orderDeliveryStore.task_list ?? [];
    const filtered = statusId ? list.filter(item => String(item?.task_status_id) === statusId) : list;
    setTableData(filtered.slice(0, pageSize));
  }, [orderDeliveryStore, statusId, pageSize]);

  return (
    <>
      <section className="w-full min-w-[170px] max-w-[200px]">
        <div className="w-full">
          <div className="ml-0.5 mr-2 mt-1">
            <select
              value={statusId}
              onChange={e => setStatusId(e.target.value)}
              className="mb-2 w-full max-w-xs rounded-md border border-gray-300 bg-white px-3 py-2 text-xs text-gray-700 transition focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">All</option>
              {statusOptions.map(([value, name]) => (
                <option key={value} value={String(value)}>
                  {name}
                </option>
              ))}
            </select>
          </div>

          <div className="scrollbar-thin scrollbar-track-gray-200 h-[calc(100vh-60px)] w-full overflow-y-scroll">
            {tableData?.map(item => (
              <div key={item?.sales_order_ref_no} onClick={() => props.viewItemDetails(item?.sales_order_ref_no)}>
                <div
                  className={`cursor-pointer border-b-[1px] border-gray-300 px-2 py-2 transition ${
                    String(id) === String(item?.sales_order_ref_no) ? 'border-b-blue-400 bg-gray-200' : 'bg-white hover:!bg-gray-100'
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <span title={item?.order_recipient_name?.trim()} className="max-w-[110px] truncate text-sm text-gray-700">
                      {item?.order_recipient_name?.trim()}
                    </span>
                    <span className="text-[11px] text-gray-400">#{item?.sales_order_ref_no}</span>
                  </div>

                  <div className="mt-1 flex flex-row items-center justify-between gap-1 text-sm font-bold text-gray-800">
                    <span>{item?.total_sales_order_amount}</span>
                    <span
                      className={`truncate rounded-full px-2 py-0.5 text-[10px] font-semibold ${
                        taskStatusClass[item?.task_status_id] ?? 'bg-gray-100 text-gray-700'
                      }`}
                    >
                      {item?.task_status_name}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="clearfix ml-2 mt-3 text-center">
          <select value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </section>
    </>
  );
}

export default OrderDeliveryScroll;
